export default "<go-switch-toggle [control]=\"control\" [label]=\"label\"></go-switch-toggle>\n";